import { useEffect, useRef, useState } from "react"
import AdminNavBar from "./AdminNavBar"
import LocationNavBar from "./LocationNavBar"

const RestoreLocation = () => {

	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}

	var locationRef = useRef<HTMLSelectElement>(null)

	const [locations, setLocations] = useState<Location[]>([])
	const [msg, setMsg] = useState("")
	const [selectedLocation, setSelectedLocation] = useState<Location>({ id: 0, short_name: "", long_name: "" })
	const [isVisible, setIsVisible] = useState(false)

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations?deleted=true")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}

	const handleSelectChange = async () => {
		if (locationRef && locationRef.current) {
			const id = locationRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/locationByID?id=" + id);
			const location = await response.json()
			setSelectedLocation(location)
			setIsVisible(true)
			setMsg("")
		}
	}

	const handleRestore = async () => {
		if (locationRef && locationRef.current) {
			const id = locationRef.current.value
			const resp = await fetch(process.env.REACT_APP_API+"/api/locations?id=" + id, {
				method: "PATCH",
			});
			if (resp.status === 200) {
				setMsg("Restored " + selectedLocation.long_name + " successfully")
			}
			else {
				setMsg("Failed to restore " + selectedLocation.long_name)
			}
			setIsVisible(false)
			getLocations()
		}
	}

	useEffect(() => {
		getLocations()
	}, [])

	return (
		<div className="resilire">
			<AdminNavBar />
			<LocationNavBar />
			<h3>Restore Location</h3>
			<select id="units" onChange={handleSelectChange} ref={locationRef}>
				<option value=""></option>
				{locations.map((location) => (
					<option value={location.id} key={location.id}>{location.long_name}</option>
				))}
			</select>
			{isVisible && (
				<div className="resilire">
					<button onClick={() => handleRestore()}>Restore {selectedLocation.long_name}</button>
				</div>
			)}
			<p>{msg}</p>
		</div>
	)
}

export default RestoreLocation;
